import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-cgu',
  templateUrl: './cgu.component.html',
  styleUrls: ['./cgu.component.scss'],
})
export class CguComponent implements OnInit {

  constructor(private modalController: ModalController) { }

  ngOnInit() {}

  close(data?) {
    this.modalController.dismiss(data);
  }
}
